import React from "react";
import PropTypes from "prop-types";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import classNames from "classnames";

import { Button } from "@material-ui/core";

const useStyles = makeStyles(theme =>
  createStyles({
    root: {
      ...theme.typography.h6,
      marginRight: theme.spacing(1),
    },
    h40: {
      height: 40,
      padding: "8px 16px",
    },
    h28: {
      height: 28,
      padding: "6px 16px",
    },
    defaultRoot: {
      // padding: "8px 28px",
      borderRadius: theme.spacing(2.5),
      // [theme.breakpoints.down("sm")]: {
      //   padding: "8px 16px",
      // },
    },
    tagRoot: {
      paddingLeft: 14,
      paddingRight: 14,
      borderRadius: theme.spacing(2),
    },
    textRoot: {
      // height:
    },
    active: {
      color: "white",
      backgroundColor: theme.palette.primary.main,
      "&:hover": {
        backgroundColor: theme.palette.primary.dark,
        color: "white",
      },
    },
    outlineActive: {
      color: theme.palette.primary.main,
      border: "solid 1px",
      borderColor: theme.palette.primary.main,
      backgroundColor: "white",
      "&:hover": {
        color: theme.palette.primary.dark,
        borderColor: theme.palette.primary.dark,
        backgroundColor: "white",
      },
    },
    textActive: {
      color: theme.palette.primary.main,
      backgroundColor: "transparent",
      "&:hover": {
        color: theme.palette.primary.main,
        backgroundColor: "transparent",
      },
    },
    inactive: {
      color: "white",
      backgroundColor: theme.palette.common.grey[300],
      "&:hover": {
        color: "white",
        backgroundColor: theme.palette.common.grey[300],
      },
      "&:disabled": {
        color: "white",
        backgroundColor: theme.palette.common.grey[300],
      },
    },
  }),
);

const StyledButton = props => {
  const classes = useStyles();

  const { variant = "default", className, height = 40, ...rest } = props;

  const getVaraintClass = () => {
    if (variant === "tag") {
      return classes.tagRoot;
    }
    if (variant === "text") {
      return classes.textRoot;
    }

    return classes.defaultRoot;
  };

  const getActiveClass = () => {
    if (variant === "outline") {
      return classes.outlineActive;
    }

    if (variant === "inactive") {
      return classes.inactive;
    }

    if (variant === "text") {
      return classes.textActive;
    }

    return classes.active;
  };

  const variantClass = getVaraintClass();
  const activeClass = getActiveClass();
  const heightClass = variant === 'text' ? {} : { [classes.h28]: height === 28, [classes.h40]: height === 40 }
  return (
    <Button
      className={classNames(
        className,
        classes.root,
        heightClass,
        variantClass,
        activeClass,
      )}
      // style={{ height }}
      disabled={variant === "inactive" ? true : false}
      {...rest}
    />
  );
};

StyledButton.defaultProps = {};

StyledButton.propsTypes = {};

export default StyledButton;
